import axios from "axios";
import { API_BASE_URL } from './config';

// API_BASE_URL from config is the host (e.g. http://localhost:3001)
// Many legacy axios calls expect a '/api' prefix, so compose a base with that path.
const BASE = `${API_BASE_URL}`;

// Save APIs

export const saveZone = async (data) => {
  return axios.post(`${BASE}/HealthProduct/SaveHealthProductZone`, data);
};
  
export const savePlan = async (data) => {
  return axios.post(`${BASE}/HealthProduct/SaveHealthProductPlan`, data);
};

export const submitHealthProduct = async (data) => {
  return axios.post(`${BASE}/HealthProduct/SaveHealthProducts`, data);
};

export const submitBranchMaster = async (data) => {
  return axios.post(`${BASE}/BranchMaster/SaveBranchMaster`, data);
};

export const submitAgencyMaster = async (data) => {
  return axios.post(`${BASE}/Agency/SaveAgencyMaster`, data);
};

export const submitOtherProductMaster = async (data) => {
  return axios.post(`${BASE}/OtherProduct/SaveOtherProductMaster`, data);
};

export const submitMotorProductMaster = async (data) => {
  return axios.post(`${BASE}/MotorProduct/SaveMotorProductMaster`, data);
};

export const submitMotorAddOnsMaster = async (data) => {
  return axios.post(`${BASE}/MotorProduct/SaveMotorAddOnMaster`, data);
};

// Get APIs

// export const getInsurance = async (data) => {
//   return axios.get(`${API_BASE_URL}/get-insuranceList`, data);
// };

export const getInsurance = async (params = {}) => {
  try {
  const res = await axios.get(`${BASE}/common/get-insuranceList`, { params });
    return res.data; 
  } catch (error) {
    console.error("Error fetching insurance data:", error);
    throw error;
  }
};

// export const getAgencies = async (data) => {
//   console.log("Fetching agencies with data:", data);
//     try {
//     const res = await axios.get(`${API_BASE_URL}/get-Agency`, { data });
//     console.log(`hyyyyyyy:`, res);
//     return res.data; 
//   } catch (error) {
//     console.error("Error fetching insurance data:", error);
//     throw error;
//   }
//   // return axios.get(`${API_BASE_URL}/get-Agency`, data);
// };
export const getAgencies = async (data) => {
  console.log("Fetching agencies with data:", data);
    try {
  const res = await axios.get(`${BASE}/get-Agency`, { data });
    console.log(`hyyyyyyy:`, res);
    return res.data; 
  } catch (error) {
    console.error("Error fetching insurance data:", error);
    throw error;
  }
  // return axios.get(`${API_BASE_URL}/get-Agency`, data);
};

export const getBranches = async (data) => {
  return axios.post(`${BASE}/BranchMaster/BranchMaster`, data);
};

export const getOtherProducts = async (data) => {
  return axios.post(`${BASE}/OtherProduct/OtherProductMaster`, data);
};

export const getMotorProducts = async (data) => {
  return axios.post(`${BASE}/MotorProduct/MotorProductMaster`, data);
};

export const getMotorAddons = async (data) => {
  return axios.post(`${BASE}/MotorProduct/MotorAddOnMaster`, data);
};

export const getHealthProducts = async (data) => {
  return axios.post(`${BASE}/HealthProduct/HealthProductsMaster`, data);
};




// import axios from "axios";
// import { API_BASE_URL } from "./config";

// const apiClient = axios.create({
//   baseURL: API_BASE_URL,
//   timeout: 15000,
//   headers: { "Content-Type": "application/json" },
// });

// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token"); // replace/get token from auth slice if available
//     if (token) config.headers.Authorization = `Bearer ${token}`;
//     return config;
//   },
//   (err) => Promise.reject(err)
// );

// apiClient.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     // central logging, refresh token logic, Sentry, toast, etc.
//     return Promise.reject(err);
//   }
// );

// export default apiClient;